<app-import-form [title]="'Invoice'" (whenFileSelected)="selectedFiles($event)" (returnToMain)="backToInvoice()"> 

</app-import-form>